/**
 * Waits for the sidebar animation to fully complete before entering
 * fullscreen mode.
 *
 * On some low-end Android tablets, requesting fullscreen while the sidebar
 * animation is still running can cause rendering issues where the screen
 * briefly turns black. Adding a small delay after the animation completes
 * allows the browser layout and GPU compositing to settle before the
 * fullscreen transition begins.
 */
export async function waitForSidebarAnimationToComplete() {
  const sidebarAnimationDuration = 250; // ms
  const buffer = 50; // ms
  const timeoutDelay = sidebarAnimationDuration + buffer;
  await new Promise((resolve) => setTimeout(resolve, timeoutDelay));
}
